module.exports = __webpack_public_path__ + "img/xk-bg.fb18b05e.jpg";